import React, { useEffect } from "react";

const Redirect = () => {
  useEffect(() => {
    setTimeout(() => {
      window.location.href = "https://app.alfredchat.com.br/register";
    }, 500);
  }, []);

  return (
    <div
      style={{
        background: "#000000",
        width: "100%",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: 50,
          height: 50,
          border: "3px solid #e4da1b",
          borderTop: "3px solid transparent",
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
        }}
      >
        <style>
          {`
      @keyframes spin {
        to { transform: rotate(360deg); }
      }
    `}
        </style>
      </div>
    </div>
  );
};

export default Redirect;
